import React, { useEffect } from "react";
import { Modal, Button, FormInput } from "components/common";
import { toast } from "react-toastify";
import PropTypes from 'prop-types';
import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import { createPositionGroup, updatePositionGroup } from "redux/organization/positionGroupSlice";

const PositionGroupForm = ({ showModal, setshowModal, title, record }) => {
  const { register, handleSubmit, formState: { errors }, setValue } = useForm();

  const dispatch = useDispatch();

  useEffect(() => {
    if (record) {
      Object.entries(record).forEach(([key, value]) => {
        setValue(key, value)
      })
    }
  }, [setValue, record])

  const closeModal = () => {
    setshowModal(false)
  }

  const onSubmit = async (data) => {
    try {
      if (record) {
        const positionGroupId = record.id
        dispatch(updatePositionGroup({ positionGroupId, data }))
      }
      else {
        dispatch(createPositionGroup(data))
      }

      closeModal()
    }
    catch (error) {
      toast.error(error.message)
    }
  }

  return (
    <Modal
      show={showModal}
      onHide={closeModal}
      title={title}
      backdropClick={false}
      footer={(
        <>
          <Button size="sm" type="submit" form="position-group-form">Save</Button>
          <Button size="sm" variant="danger" onClick={closeModal}>Cancel</Button>
        </>
      )}
    >
      <form id="position-group-form" onSubmit={handleSubmit(onSubmit)}>
        <FormInput
          label="Name"
          placeholder="Name"
          error={errors.name?.message}
          {...register("name", {
            required: "Name must be required."
          })}
        />
      </form>
    </Modal>
  )
}

PositionGroupForm.propTypes = {
  showModal: PropTypes.bool,
  setshowModal: PropTypes.func,
  title: PropTypes.string,
  record: PropTypes.object
}

export default PositionGroupForm
